export const load = () => ({
	h1: 'Indow Windows Terms & Conditions',
	title: 'Sales Terms For All Indow Window Purchases',
	description: 'Understand the terms of sale for your Indow Windows order.',
	showTitle: true,
});
